import { ReviewItem } from './ReviewItem';

export const TestimonialsSection = () => {
  return (
    <section className="testi">
      <div className="div-block">
        <h2
          data-w-id="00e1dfea-1c1d-4355-56c7-f2dacf35ae84"
          style={{ opacity: 0 }}
          className="testimonials"
        >
          <strong className="bold-text-4">testimonials</strong>
        </h2>
        <div
          data-w-id="6ed00171-f7dd-bbad-10a2-1a3f5ba161f1"
          style={{ opacity: 0 }}
          className="testi-desc"
        >
          <p className="listing-des white">
            Feed your curiosity and explore something new. From thought-provoking
            talks andlanguage classes to hands-on workshops and
          </p>
        </div>
        <a
          data-w-id="cbc4238e-09b3-ccb5-d0a7-dfb0f56bcf84"
          style={{ opacity: 0 }}
          href="/#"
          className="lisitng-btn--light w-inline-block"
        >
          <div className="text-block">Explore</div>
        </a>
      </div>
      <div
        data-w-id="030a9470-5d70-8790-697b-51e492f7564c"
        style={{ opacity: 0 }}
        className="section_reviews"
      >
        <div className="padding-global">
          <div className="container-large">
            <div className="review-component">
              <div
                data-w-id="030a9470-5d70-8790-697b-51e492f75661"
                style={{ opacity: 0 }}
                className="reviews-wrapper"
              >
                <div className="left-reviews-container">
                  <div className="reverse scroll">
                    <div className="collection-list-wrapper">
                      <div className="collection-list">
                        <div className="collection-item">
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right-reviews-container">
                  <div className="scroll">
                    <div className="collection-list-wrapper">
                      <div className="collection-list">
                        <div className="collection-item">
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="left-reviews-container">
                  <div className="reverse scroll">
                    <div className="collection-list-wrapper">
                      <div className="collection-list">
                        <div className="collection-item">
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                          <ReviewItem />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="testi-grad" />
        <div className="w-embed">
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n  @keyframes scroll-vertical {\n    from {\n      transform: translateY(0);\n    }\n    to {\n      transform: translateY(calc(-100% - 1rem));\n    }\n  }\n  @keyframes scroll-horizontal {\n    from {\n      transform: translateX(0);\n    }\n    to {\n      transform: translateX(calc(-100% - 1rem));\n    }\n  }\n  .scroll {\n    animation: scroll-vertical 50s linear infinite;\n  }\n  .reverse {\n    animation-direction: reverse;\n  }\n  .right-reviews-container {\n    height: 100%;\n    position: relative;\n  }\n  .review-items {\n    margin-bottom: 10px;\n  }\n  @media (max-width: 767px) {\n    /* switch to horizontal scrolling for mobile landscape and mobile view */\n    .scroll {\n      animation: scroll-horizontal 50s linear infinite;\n      display: flex;\n      flex-wrap: nowrap;\n      overflow-x: scroll;\n      overflow-y: hidden;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n"
            }}
          />
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n  .vertical-text {\n    writing-mode: vertical-rl;\n  }\n"
            }}
          />
        </div>
      </div>
    </section>
  );
};
